<template>
<div>
<el-row>
<el-col :span="2"><div class="grid-content"></div></el-col>
<el-col :span="20">
<div class="title">
<h1>VR文化展览用户体验模型</h1>
</div>
<div class="picture project1-after-video">
<img src="../assets/project1_8.png.webp"/>
</div>
<div class="paper_published">
                    Gong, Q.*, Zou, N., Yang, W. et al. (2024). User experience model and design strategies for virtual reality-based cultural heritage exhibition. Virtual Reality, 28(2).
                </div>
<div class="abstract">
                    基于虚拟现实（VR）的文化遗产展览（VRCHE）是基于VR的博物馆展览（虚拟现实ME）的重要类型。 VRCHE的用户体验（UX）设计遇到了机遇，并且由于基于VR的交互界面与传统交互界面在人机交互（人机交互）方面的差异，因此提出VRCHE的UX模型至关重要。尽管已有一些研究 VRCHE 的用户体验模型的工作，但由于目前使用的方法和实验材料，它们还不够完整，无法描述 VRCHE 的用户体验或提供任何设计策略。这项研究利用结合了定性和定量方法的扎根理论进行了实验。然后，研究综合了扎根理论的三级编码和定量分析结果，利用理论编码构建了 VRCHE用户体验 的详细模型，并提出了设计策略。
                </div>
</el-col>
<el-col :span="2"><div class="grid-content"></div></el-col>
</el-row>
<el-row :gutter="40" style="margin-top: 50px">
<el-col :span="2"><div class="grid-content"></div></el-col>
<el-col :span="8">
<div class="picture">
<img src="../assets/project1_1.png.webp"/>
<img src="../assets/project1_2.png.webp"/>
<img src="../assets/project1_3.png.webp"/>
</div>
</el-col>
<el-col :span="12">
<div class="sub-title">
                    基于扎根理论的实验程序                </div>
<div class="text">
                    本研究的目的是调查 VRCHE 中促进游客沉浸和逃避现实的用户体验元素。本研究采用基于扎根理论的混合方法来解决文献综述中发现的研究空白。具体来说，本研究首先根据VRCHE展览的内容和设计特点将其分为四种类型，然后与参与者进行实验，收集定性和定量数据。接下来，本研究对数据进行三级编码和统计分析，并利用理论编码开发全面而详细的 VRCHE用户体验模型，揭示 UX 的维度、元素和关系。最后，本研究根据模型和研究结果为 VRCHE 开发人员和从业者提供了设计策略。
                    根据扎根理论的基本原则，研究问题应该在整个实验过程中自发出现（格拉泽和施特劳斯，1999）。
                    <br/><br/> 研究者用于构建VRCHE的“局部概念”（根据格拉泽和施特劳斯（1999），这可以视为结构概念）的文献综述提出了VRCHE的四个类别。邹等人。 (2021) 将四个 VRCHE 类别描述如下：
                    <br/><br/>  文物层面：VRCHE的文物层面侧重于物质文化遗产或非物质遗产的有形方面。这种展览过程是结构化的，参观者根据展览对象的固定外观逐渐了解其内容。
                    <br/><br/>  行为层面：在行为层面的展览中，参观者按照结构化的流程主动控制展品并学习如何使用它们，其中任务设计往往很明显。
                    <br/><br/>  精神层面：精神层面展览的展示过程往往是非结构化的，采用历史情境重构或特效等策略来营造氛围。参观者没有任何任务，而是根据认知方法整合展品来解释物品。
                    <br/><br/> 创作层面：在创作层面，往往有任务设计，但没有明确的实现方式，为参观者提供了更多的探索自由。
                    <br/><br/> 因此，分为任务型和结构化展览、任务型和非结构化展览、非任务型和结构化展览、非任务型和非结构化展览这四个类别。像这样的分类技术可以通过用户体验角度区分常见的展览类型，并将它们与用户体验设计明智地联系起来。图3显示了四个象限中的四种展览类型。
                    <br/><br/> 基于同样的“民间玩具”展览主题，研究人员选取了华容道（一种中国木板玩具，其名字来源于三国故事）、孔明锁（一种中国民间榫卯结构的木制玩具）、七巧板、投壶（中国古代文人和官员在宴会上玩的投掷游戏）和河内塔。这些玩具可以转化为四种类型的展览，有传播和展示的作用，象征着礼仪、工艺、文学、创造力和数学。
                    <br/><br/> 研究人员进行了两项实验。在实验 A 中，参与者按照一定的顺序被动体验不同类型的 VRCHE，以探索他们的用户体验元素。在实验 B 中，参与者根据探索访问者最基本的用户体验期望的动机来确定 VRCHE 的顺序。最终的 UX 模型旨在展示不同的 UX 方面如何满足不同 VRCHE 访问者的期望。因此，实验A的概念类别构建将参考实验B的结果。材料中的所有文字均以中文呈现，因为它是参与者的母语。所有测试素材均使用Unity（美国统一技术公司开发，版本2019.1.9f1）制作，并使用HTC VIVE pro 眼睛（中国HTC公司制造）进行展示。
                </div>
</el-col>
<el-col :span="2"><div class="grid-content"></div></el-col>
</el-row>
<el-row :gutter="40" style="margin-top: 50px">
<el-col :span="2"><div class="grid-content"></div></el-col>
<el-col :span="12">
<div class="sub-title">
                    试点研究：研究问题的出现和初步理论的构建
                </div>
<div class="text">
                    卡巴西 的评估得出的结论是，专业用户和普通用户报告了不同的 VRCHE用户体验特征（卡巴西，2017）。研究人员选择了有 VR 经验和没有 VR 经验的受试者进行研究。实验策略是不断招募新的志愿者，直到研究人员获得足够的数据并且无法得出新的见解为止（格拉泽和施特劳斯，1999）。选择了四名 22 至 25 岁的参与者，其中两名女性，两名男性。一名有更多 VR 经验（开发过 VR 应用），一名有一定经验，两名没有 VR 经验
                    <br/><br/> 目标是（1）明确研究问题，（2）提出初步假设以改进正式研究数据收集，（3）识别实验设计缺陷，以及（4）消除可能影响参与者体验的任何独特特征。
                    <br/><br/>  数据处理过程如下：首先，将实验中收集的所有音频数据转录为文本。然后，研究人员逐一对比视频和屏幕录制内容，尽可能精细地还原了参与者原话的转录准确性以及研究人员的干预。然后，研究人员收集并记录了在视频中观察到的行为协议（包括所有具有特定含义的值得注意的行为，例如大笑或害怕）。下一步涉及根据参与者的语音模式对数据进行分段，删除无用的数据，并获得原始分段数据（所罗门，1995）。最后使用QDA 矿机精简版（加拿大普罗瓦利斯研究公司开发，版本2.0.9）进行开放编码（这意味着研究人员将分段协议尽可能概括为简洁的代码，附录A中的表2列出了一些示例），并将数据分为以下三个概念类别：“实验过程问题”、“体验元素”和“体验期望”。然后对一半以上参与者数据中出现的代码进行筛选。
                    <br/><br/>  结果如下： 首先，所有参与者将实验 B 与实验 A 进行比较，发现实验 B 受到实验 A 的影响。由于两个实验的设置不同，实验 A 对实验 B 的影响与实验 B 对实验 A 的影响不一样，导致了不对称的顺序效应。试点研究的重复测量设计存在缺陷。其次，在实验B中，两名参与者表示他们熟悉河内塔；因此，他们对下一次经历的选择以及对该选择的解释发生了很大的改变，导致了错误的发现。第三，研究问题自然出现如下：VRCHE 的用户体验元素之间有什么联系？最后，根据用户体验要素和期望得出以下结论：（1）不同参与者对同一实验材料的用户体验期望有所不同。 (2)不同参与者对同一实验材料的用户体验要素有所不同。 (3)用户体验体验是因果相关的。

                </div>
</el-col>
<el-col :span="8">
<div class="picture">
<img src="../assets/project1_4.png.webp"/>
</div>
</el-col>
<el-col :span="2"><div class="grid-content"></div></el-col>
</el-row>
<el-row :gutter="40" style="margin-top: 50px">
<el-col :span="2"><div class="grid-content"></div></el-col>
<el-col :span="12">
<div class="sub-title">
                    正式研究：理论抽样                </div>
<div class="text">
                    正式研究扩展了政治研究的初步理论。 (1) 参与者的用户体验期望是什么？ （2）为什么不同参与者的用户体验会有所不同？ (3) 参与者的用户体验元素之间有什么联系？
                    <br/><br/>  图 除了将参与者分为两组进行实验 A 和 B 外，其余实验过程与预研究相同。此外，正式实验的数据收集和处理（不包括编码）与试点研究相同。如4.3.3所述，将正式实验中的所有数据（视频、音频、观察记录等）处理成原始片段数据，为后续使用编码的数据分析过程做准备。
                </div>
</el-col>
<el-col :span="8">
<div class="picture">
</div>
</el-col>
<el-col :span="2"><div class="grid-content"></div></el-col>
</el-row>
<el-row :gutter="40" style="margin-top: 50px">
<el-col :span="2"><div class="grid-content"></div></el-col>
<el-col :span="8">
<div class="picture">
<img src="../assets/project1_5.png.webp"/>
<div class="sub-title">
<br/> <br/><br/><br/>结果与讨论：理论编码和描述性统计
                    </div>
<div class="text">
                        下图总结了所使用的代码并显示了 VRCHE用户体验模型，展示了 UX 构造。当参观者将现实世界的知识带入虚拟环境时，通过回忆、联想等认知方法进行回溯，并与本次展览中通过感官感知到的知识相结合形成元认知的过程。元认知过程与感官知觉和认知过程一起，刺激访客形成用户体验和行为意图，包括情感、学习和易用性。这些体验特征有着复杂的因果关系，但它们都最终体现在情感上并影响游客的行为意图。 5.1-5.4 详细解释了这些关系。
                    </div>
<div class="picture">
<img src="../assets/project1_6.png.webp"/>
</div>
</div>
</el-col>
<el-col :span="12">
<div class="sub-title">
                    方法论
                </div>
<div class="text">
                    编码方法利用 QDA 矿工，并基于 施特劳斯的扎根理论分析方法（施特劳斯，1987）。                    <br/><br/>为了简化计算，更注重验证方法的可行性，结合李克特五点量表的原理，本研究将所有需要设计者分配的数字分为五个级别，取值分别为1、3、5、7、9
                    <br/><br/>  开放编码
                    <br/><br/>  在实验A中，研究人员保留了尽可能多的原始数据，同时公开总结并生成尽可能多的新代码。在实验 B 中，每个参与者的数据都被标记为有一个或多个原因。在实验A中，找到了251个代码。在实验B中，发现了5个代码。开放编码示例如表 2（附录 A）所示。
                    <br/><br/> 轴向编码
                    <br/><br/> 轴向编码的第一步是对实验B中使用的代码进行聚类。根据参观者的用户体验期望，研究人员对实验B中的“学习展品信息”、“娱乐”和“完成任务”三个概念类别进行聚类，并将相关代码分类到这三个概念类别中。附录 A 中的表 3 显示了编码结果和案例百分比。
                    <br/><br/>  第二步是在实验B和已知理论的基础上对实验A中使用的代码进行聚类。聚类改进了模型的解释。根据邹等人的玫瑰模型，实验B中通过聚类得到的三个概念类别是“学习”、“情感”和“易用性”，这支持了玫瑰模型的这一要素。在实验 A 中，研究人员将代码分为“情感”、“学习”、“易用性”和“其他”类别。然后，研究人员发现了单一案例代码，检查了原始数据中是否有类似代码，如果没有发现则将其删除。
                    <br/><br/> 第三步是对实验A中的新概念类别进行聚类。在实验A中，研究人员形成了几个新的概念类别，包括“自我评价”、“比较评价”、“归纳总结”、“了解更多展品”和“时间感知”。内夫对自我评价的定义结合了自我判断和自我同情的概念（内夫，2003）。两者都已被证明可以调节情绪（菲利普斯，2021），因此研究人员将它们与情绪联系起来。在 VR 增强博物馆体验的研究中（巴拉达兰 等人，2022），巴拉达兰等人。将“时间感知”归类为“享受”，并强调其与情感的相互作用。然而，在实验中，提到时间感知的参与者也提到了信息获取。一位参与者表示，“加长动画没有传达足够的重要信息，所以我很无聊。”情绪影响是间接的，而时间感知是一种中枢认知（斯帕普é 等，2022），因此研究人员将其归类为“学习”下的“认知”。研究的比较评价和归纳总结需要分析认知材料并表达主观观点。根据 古特维尔 (2017) 的说法，这些都是元认知技能。根据玫瑰模型，“了解更多展品”可以与“行为倾向”联系起来，尽管在实验 B 中没有检测到这一点。
                    <br/><br/> 下一步是重建实验A中获得的概念类别，这是根据古特维尔关于有声思考数据、数据重新筛选和元认知相关数据编码的方法进行的（古特维尔，2017）。元认知是一种自我调节；因此，它具有三个阶段，即模型比较、模型执行和单实例推理，这包括在 齐默尔曼 的自我调节阶段（齐默尔曼，2000）。研究人员将元认知解构为“以常识为模型”、“以参观中学到的知识为模型”、“以文化展览的现有知识为模型”、“以游戏的现有知识为模型”和“以展品的现有知识为模型”五个概念。实验A提供了121个代码、5个一级概念类别、20个二级概念类别和19个三级概念类别（附录A中的表4）。
                    <br/><br/> 最后一步涉及建立关系。研究人员根据实验 A 的目标和原始数据中的因果关系将每个子类别关联起来。他们将想法类别之间构建的关系网络保存在Neo4j中。表 5 显示了这些示例
                    <br/><br/>  选择性编码
                    <br/><br/>  将三级概念类别简化为两级简化了实验A的编码关系网络。研究人员对每个子类别中的案例进行了计数和评估，以确定有多少参与者引用了每个子类别。表1显示了15个子类别，其中14个子类别的案例数超过50%，1个子类别为行为意图。理论编码侧重于子类别及其关系。研究人员随后使用 neo4j 密码 查询关系网络。
                </div>
</el-col>
<el-col :span="2"><div class="grid-content"></div></el-col>
</el-row>
</div>
</template>

<script>
    export default {
        name: "Project1Zh"
    }
</script>

<style scoped>
    .paper_published {
  margin-top: 40px;
  font-size: 15px;
  color: #333;
  font-weight: 400;
  text-align: justify;
  line-height: 1.9;
  border-bottom: 1px solid #333;
  padding-bottom: 6px;
}
    .picture img{
        width: 100%;
    }
    .project1-after-video {
        margin-top: 60px;
    }
    .sub-title{
        margin-bottom: 20px;
        font-size: 15px;
        color: #666;
        font-weight: 400;
        text-align: justify;
    }
    .text{
        font-size: 15px;
        color: #333;
        font-weight: 100;
        text-align: justify;
    }
    .abstract{
        margin-top: 40px;
        font-size: 15px;
        color: #333;
        font-weight: 100;
        text-align: justify;
    }
    .grid-content{
        min-height: 36px;
    }
    .title{
        margin-top: 100px;
        text-align: center;

    }
    .title a{
        color: #333;
    }
    .title p{
        color: #aaa;
        line-height: 30px;
    }
    .title h1{
        font-size:30px;
        font-weight: 100;
        letter-spacing:6px;
        color: #333333;
    }
</style>